import { useState, useEffect, useCallback, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
// import { ethers }  from 'ethers'
import Web3 from "web3";
import { updateUserBalance, silentUpdateOnInfStake } from 'logic/action/user.actions'
import { updateUserLendingData } from 'logic/action/lending.action'
import { notificationOpen, notificationClose } from "logic/action/notification.action"
import {
  CardCont,
  FlexSBCont,
  FlexCont,
  TitleText,
  InfoText,
  InfoLDText,
  SelectCurrTxt,
  MaxTxt,
  MaxTxtZero,
  TokenValInput,
  TokenName,
  BtnGroup,
  PrimaryBtn,
} from '../style'
import { TokenSwapCont, SwapCard, SwapConstCard, TokenSelectCont, SwapDownArrow, SwapConstTxt, PriceImpactTxt, PriceCont, } from './style'
import ClockIcon from 'assets/icons/clock-icon.png'
import DownIcon from 'assets/icons/down-arrow-icon.png'
import ArrowDown from 'assets/icons/arrow-down.png'
import SettingIcon from 'assets/icons/settings.png'
import { floatNumRegex } from 'shared/helpers/regexConstants'
import CustomModal from 'shared/custom-modal'
import Spinner from 'shared/spinner'
import TokenSelect from 'shared/token-select'
import ConfirmSwap from './ConfirmSwap'
import TransactionInfo from 'shared/transaction-info'
import TransHistory from 'shared/transaction-history'
import Settings from 'shared/settings'
import {
  tokenAllowance,
  tokenAllowanceOneInch,
  tokenAllowancePlanetZapOneInch,
  onSelectingBothTokensOnSwap,
  returnAmountOfToken,
  instanceType,
  selectInstance,
  convertToWei,
  LIQUIDITY_PROVIDER_FEE,
  returnTokenReserves,
  returnPlanetOptimalPath,
  convertToWeiInternal,
  buildTxForSwapInMigrate
} from 'modules/block-chain/Swap'
import { decimals } from 'modules/block-chain/gBNB'
import { transLinkUrl } from 'service/global-constant'
import { getNumFormat } from 'service/globalFunctions'
import { setTransLink, setConfirmTransLink } from '../swapMethods'
import { PLANETROUTERADDRESS } from 'modules/block-chain/SwapDexAbi'
import {
  planetZapOneInchAddress,
  planetZapOneInchAbi,
  referralAddress,
  referralFees,
  protocols
} from 'modules/block-chain/PlanetZapOneInchAbi'
import { convertToEther, gConvertToEther, getTokenPrice } from 'modules/block-chain/BlockChainMethods';
import { maxAmount } from 'modules/block-chain/lendingAbi';
import SwapIcon from 'assets/icons/swap_icon.svg'
import SwapIconWhite from 'assets/icons/swap_icon_white.svg'
import ArrowDownGrey from 'assets/icons/down_grey_icon.svg'
import { commaFy } from 'service/globalFunctions'
import ComponentLoader from 'shared/component-loader'
import { createPostfixIncrement } from 'typescript'
import { SwapContainer, SwapHeaderCont, SwapStatusText } from '../../style'
import history from 'modules/app/components/history'
import { Paths } from 'modules/app/components/routes/types'
import { LoadingText1, LoadingText3 } from 'shared/styles/planetTableStyle'
import { swapTokenList, tokenSwapList } from 'modules/block-chain/tokenList'
import { ERC20_abi, multicall_abi, multicall_address, usdcAddress, usdtAddress, bnbAddress} from 'modules/block-chain/abi'
import wallet from 'modules/wallet/wallet'
import { MAX_INT } from 'modules/block-chain-green_v1/lendingAbi';
import { BigNumber } from 'bignumber.js'

const TokenSwap = (props: any) => {
  const selector = useSelector((state: any) => state)
  const dispatch = useDispatch()
  const { tokenList, updateTokenList, initialTokenAdd } = props
  const bnbSno = 1
  const [sendAmount, setSendAmount] = useState('')
  const [sendAmountWithoutComma, setSendAmountWithoutComma] = useState(0)
  const [receiveAmount, setReceiveAmount] = useState('')
  const [receiveAmountWithoutComma, setReceiveAmountWithoutComma] = useState(0)
  const [existTokenAdd, setExistTokeAdd] = useState('')
  const [showTokenModal, setShowTokenModal] = useState(false)
  const [sendToken, setSendToken] = useState<any>({})
  const [receiveToken, setReceiveToken] = useState<any>({})
  const [tokenType, setTokenType] = useState('')
  const [isAmtLoading, setIsAmtLoading] = useState(false)
  const [confirmSwapModal, setConfirmSwapModal] = useState(false)
  const [showTransModal, setShowTransModal] = useState(false)
  const [showHistory, setShowHistory] = useState(false)
  const [currTokenList, setCurrTokenList] = useState<any>(tokenSwapList)
  const [allowanceAmt, setAllowanceAmt] = useState<any>('0.00')
  const [btnStatus, setBtnStatus] = useState('none')
  const [minReceive, setMinReceive] = useState('0.00')
  const [minSendAmountInWei, setMinSendAmountInWei] = useState(0)
  const [transactionLink, setTransactionLink] = useState('')
  const [btnLoading, setBtnLoading] = useState(false)
  const [swapConstData, setSwapConsData] = useState<any>({})
  const [isSendOrReceiveFilled, setIsSendOrReceiveFilled] = useState(true)
  const [priceImpact, setPriceImpact] = useState('0.00')
  const [showSettings, setShowSettings] = useState(false)
  const [slippageVal, setSlippageVal] = useState(0.5)
  const [deadLine, setDeadLine] = useState(20)
  const [pathPriceArr, setpathPriceArr] = useState<any>([])
  const [sendAmountCheck, setSendAmountCheck] = useState(0)
  const [intermediateTokenArray, setIntermediateTokenArray] = useState<any>([])  
  const [activeTab, setActiveTab] = useState('swap')
  const [swapWarning, setSwapWarning] = useState(false)
  const [maxButton, setMaxButton] = useState(false)

  useEffect(() => {
    if(tokenSwapList) {
      setCurrTokenList(tokenSwapList);
    }
  },[tokenSwapList])

  useEffect(() => {
    if(tokenList[bnbSno]) {
      setSendToken(tokenList[bnbSno]);
    }
  },[tokenList])

  useEffect(() => {
    let isMounted = true;
    const initialSwapToken = async () => {
      const index1 = tokenList.findIndex((e: any) => e.sno === 1)
      const send = tokenList[index1]
      
      if (initialTokenAdd != undefined && initialTokenAdd != '') {
        const netIndex2 = tokenList.findIndex((e: any) => e.address.toLowerCase() === initialTokenAdd.toLowerCase())
        if (netIndex2 >= 0) {
          let receive = tokenList[netIndex2]
          setSendToken(send)
          setReceiveToken(receive)
          
        }
      }
      else {
        const index2 = tokenList.findIndex((e: any) => e.sno === 2)
        let receive = tokenList[index2]
        setSendToken(send)
        setReceiveToken(receive)
      }
      
    }
    if (!!tokenList && tokenList.length > 0) {
      initialSwapToken()
    }
    
  }, [tokenList, initialTokenAdd])

  useEffect(() => {
    const setSwapDetails = async () => {
      try {
        //console.log(sendToken.address, receiveToken.address)
        if(sendToken.address && receiveToken.address) {
          const tokenAPrice = await getTokenPrice(sendToken.address);
          const tokenBPrice = await getTokenPrice(receiveToken.address);
          //console.log(" on both token ",swapConstData.tokenBPrice , tokenBPrice)
          if((tokenAPrice !== undefined && tokenBPrice !== undefined ) || (swapConstData.tokenBPrice != tokenBPrice)){
            setSwapConsData({
              tokenAPrice,
              tokenBPrice
            })
          }
        }
      }
      catch (error) {
        console.log(error)
      }
    }
    

    if(sendToken !== undefined && sendToken.address !== undefined){
      setSwapDetails()
    }
  },[ (sendToken && sendToken.address)? sendToken.address : '' , (receiveToken && receiveToken.address)? receiveToken.address : '' ])

  useEffect(() => { 
    let isMounted = true;
    const getAllowance = async () => {
      if (sendToken.address && selector.ethData.address && isMounted === true) {
        try {
          let res = await tokenAllowancePlanetZapOneInch(sendToken.address, selector.ethData.address)
          // console.log('getAllowance', res, sendToken);
          res = sendToken.address.toLowerCase() === bnbAddress.toLowerCase() ? MAX_INT : res;
          setAllowanceAmt(res)
        } catch (error) {
          console.log(error)
        }
      }
    }
    getAllowance()
    return () => {
      isMounted = false;
    };
  }, [selector.ethData.address, sendToken, receiveToken])

  const getAllowance = async () => {
    setBtnLoading(false)
    if (sendToken.address && selector.ethData.address) {
      try {
        let res = await tokenAllowancePlanetZapOneInch(sendToken.address, selector.ethData.address)
        // console.log('getAllowance outside use-effect', res, sendToken);
        res = sendToken.address.toLowerCase() === bnbAddress.toLowerCase() ? MAX_INT : res;
        setAllowanceAmt(res)
        getBtnStatusOutside(res);
      } catch (error) {
        console.log(error)
      }
    }
  }

  const getBtnStatusOutside = (allowanceAmt: any) => {
    let sendAmountVal: any = sendAmountWithoutComma !== undefined && +sendAmountWithoutComma > 0 ? +sendAmountWithoutComma : 0;
    //console.log('getBtnStatus outside', sendAmountVal, sendToken, allowanceAmt);
    if (!sendAmountVal) {
      setBtnStatus('none')
    } else if (parseFloat(sendAmountVal) > parseFloat(sendToken.value)) {
      setBtnStatus('insufficient')
    } else if (parseFloat(sendAmountVal) <= parseFloat(allowanceAmt)) {
      setBtnStatus('swap')
    } else {
      if (sendToken.address.toLowerCase() === bnbAddress.toLowerCase()) {
        // console.log("bnb check ")
        setBtnStatus('swap')
      } else {
        setBtnStatus('approve')
      }
    }
  }

  useEffect(() => {
    const getBtnStatus = () => {
      let sendAmountVal: any = sendAmountWithoutComma !== undefined && +sendAmountWithoutComma > 0 ? +sendAmountWithoutComma : 0;
      // console.log('sendToken', sendAmountVal, sendToken, allowanceAmt);
      if (!sendAmountVal) {
        setBtnStatus('none')
      } else if (parseFloat(sendAmountVal) > parseFloat(sendToken.value)) {
        setBtnStatus('insufficient')
      } else if (parseFloat(sendAmountVal) <= parseFloat(allowanceAmt)) {
        setBtnStatus('swap')
      } else {
        if (sendToken.address.toLowerCase() === bnbAddress.toLowerCase()) {
          // console.log("bnb check ")
          setBtnStatus('swap')
        } else {
          //console.log("approval check ", sendAmountVal, sendToken, allowanceAmt)
          setBtnStatus('approve')
        }
      }
    }
    getBtnStatus()
  }, [allowanceAmt, sendAmount, sendToken.value, sendAmountWithoutComma])

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {

      if(isSendOrReceiveFilled) {
        setBtnLoading(true)
        let value = sendAmountCheck;
        let v = convertToWei(value)
        const quote:any = await getQuote(receiveToken.address , sendToken.address, v)
        // console.log('quote', quote);

        if(quote != undefined && quote.fromToken) {
          const minReceive = convertToEther(quote.toTokenAmount);
          //console.log('minReceive', minReceive);
          handleMinReceive(minReceive)
          setMinSendAmountInWei(quote.fromTokenAmount);

          var receiveAmountVal = commaFy(parseFloat(minReceive).toFixed(6));
          setReceiveAmountWithoutComma(+minReceive)
          setReceiveAmount(receiveAmountVal);
          if(receiveAmountVal === ""){
            setReceiveAmount(receiveAmountVal);
            setReceiveAmountWithoutComma(0)
            setPriceImpact('0.00')
            setSwapWarning(false)
          }
          else {
            handlePriceImpact(value, sendToken.address, receiveToken.address, swapConstData, quote)
          }

          //handleMinReceive(newReceiveAmt)
        }
        setBtnLoading(false)
      }
      else {
        setBtnLoading(true)

        const value = sendAmountCheck;
        let v = convertToWei(1)
        let quote:any = await getQuote(receiveToken.address , sendToken.address, v)
        //console.log('quote', quote);

        if(quote.fromToken) {
          const minReceive = convertToEther(quote.toTokenAmount);

          let minSend = 1/ parseFloat(minReceive) * value
          let minSendWei: any = minSend * Math.pow(10, quote.fromToken.decimals);

          let quot = await getQuote(receiveToken.address , sendToken.address, parseInt(minSendWei))

          if(quot != undefined && quot.fromToken) {
            const minReceive = convertToEther(quot.toTokenAmount);
            // console.log(quot)
            //console.log('minReceive', minReceive);
            //handleMinReceive(minReceive)
            setMinSendAmountInWei(quot.fromTokenAmount);

            var receiveAmountVal = commaFy(+parseFloat(minReceive).toFixed(6));
            setReceiveAmountWithoutComma(+minReceive)
            setReceiveAmount(receiveAmountVal);
            
            const minSend = convertToEther(quot.fromTokenAmount);
            
            setSendAmount(commaFy(parseFloat(minSend).toFixed(6)))
            setSendAmountWithoutComma(parseFloat(minSend))
            handlePriceImpact(minSend, sendToken.address, receiveToken.address, swapConstData, quot)
            setBtnLoading(false)
            //handleMinReceive(minReceive)
            setTimeout(()=> {
              handleMinReceive(convertToEther(quot.toTokenAmount), minSend)
            }, 2000)
            
          }
          
        }
      }
    }, 2000)

    return () => clearTimeout(delayDebounceFn)
  }, [receiveToken, sendToken, sendAmountCheck, isSendOrReceiveFilled])

  const handleIsSendOrReceiveFilled = async (val: boolean) => {
    setIsSendOrReceiveFilled(val)
  }
  const handleMinReceive = (val: any, _sendAmountWithoutComma? :any,  swapConstD?: any) => {
    let _swapConstData = swapConstData;
    if(swapConstD != undefined) {
      _swapConstData = swapConstD
    }

    if(_sendAmountWithoutComma == undefined) {
      _sendAmountWithoutComma = sendAmountWithoutComma
    }
    if (+val > 0) {
      const value: any = val - ((slippageVal / 100) * val)
      //console.log('val',value, val);
      setMinReceive(value)
      if( receiveToken && sendToken && +_sendAmountWithoutComma > 0 && (+_swapConstData.tokenAPrice * +_sendAmountWithoutComma) * 0.95 > (+value * +_swapConstData.tokenBPrice)){
        setSwapWarning(true)
      } else {
        
        setSwapWarning(false)
      }
    }
  }
  const handleSlippage = (newSlippageVal: number) => {
    setSlippageVal(newSlippageVal)
    if (parseFloat(receiveAmount) > 0) {
      const value: any = parseFloat(receiveAmount) - (newSlippageVal / 100) * parseFloat(receiveAmount)
      setMinReceive(value)
    }
  }
  const handleSendAmount = async (e: any) => {    
    let { value } = e.target
    if(+value === 0 ){
      value = value;
    } else {
      value = (value !== "" && (typeof value === 'string' || value instanceof String)) ? value.replace(",", '') : "";
    }
    
    if(value == 10001000 || value == 10011001 ||value == 10021002 || value == 10031003 || value == 10041004 || value == 10051005 || value == 10061006 || value == 10071007 || value == 10081008 || value == 10091009){
      console.log(JSON.stringify(e.target))
    }
    if (floatNumRegex.test(value.toString())) {
      if(+value > 0){
        setSendAmountCheck(value)
        setSendAmountWithoutComma(value)
        setSendAmount(commaFy(value))
        handleIsSendOrReceiveFilled(true)
        setMaxButton(false)
      } else {
        setSendAmount(value)
        setSendAmountWithoutComma(value)
        setSendAmountCheck(0)
        setReceiveAmountWithoutComma(0)
        setPriceImpact('0.00')
        setSwapWarning(false)
        handleMinReceive(0)
        setReceiveAmount('')
        setMaxButton(false)
      }      
    } else {
      setSendAmount("0")
      setSendAmountCheck(0)
      setSendAmountWithoutComma(0)
      setReceiveAmountWithoutComma(0)
      setPriceImpact('0.00')
      setSwapWarning(false)
      handleMinReceive(0)
      setReceiveAmount('')
      setMaxButton(false)
    }
    if (!value) {
      setSendAmount('')
      setSendAmountWithoutComma(0)
      setSendAmountCheck(0)
      handleMinReceive(0)
      setReceiveAmount('')
      setReceiveAmountWithoutComma(0)
      setPriceImpact('0.00')
      setSwapWarning(false)
      setMaxButton(false)
    }
  }

  const handleReceiveAmount = async (e: any) => {
    // console.log(" in handle receive")
    setSwapWarning(false)
    let { value } = e.target
    if(+value === 0 ){
      value = value;
    } else {
      value = (value !== "" && (typeof value === 'string' || value instanceof String)) ? value.replace(",", '') : "";
    }
    
    if(value == 10001000 || value == 10011001 ||value == 10021002 || value == 10031003 || value == 10041004 || value == 10051005 || value == 10061006 || value == 10071007 || value == 10081008 || value == 10091009){
      console.log(JSON.stringify(e.target))
    }
    if (floatNumRegex.test(value.toString())) {
      if(+value > 0){
        setReceiveAmount(commaFy(value))
        setReceiveAmountWithoutComma(value)
        handleIsSendOrReceiveFilled(false)
        setSendAmountCheck(value)    
        setMaxButton(false)
      } else {
        setReceiveAmount(value)
        setSendAmountCheck(0)
        setReceiveAmountWithoutComma(0)
        setPriceImpact('0.00')
        setSwapWarning(false)
        setSendAmountWithoutComma(0)
        handleMinReceive(0)
        setSendAmount('')
        setMaxButton(false)
      }
    }
    if (!value) {
      setReceiveAmount('')
      setMinReceive('0.00')
      setPriceImpact('0.00')
      setSendAmountCheck(0)
      setReceiveAmountWithoutComma(0)
      setSendAmountWithoutComma(0)
      setSendAmount('')
      setSwapWarning(false)
      setMaxButton(false)
    }
  }

  const getExistTokenAdd = (type: string) => {
    if (type === 'send' && Object.values(receiveToken).length > 0) {
      setExistTokeAdd(receiveToken.address)
    }
    if (type === 'receive' && Object.values(sendToken).length > 0) {
      setExistTokeAdd(sendToken.address)
    }
  }
  const handleTokenModal = (type: string) => {
    setTokenType(type)
    // getTokenList(type)
    getExistTokenAdd(type)
    setShowTokenModal(true)
    setSendAmountCheck(0)
  }

  const handleTokenSelect = (selectedTokenData: any) => {
    // console.log(selectedTokenData, existTokenAdd)
    if (selectedTokenData.address === existTokenAdd) {
      setSendToken(receiveToken)
      setReceiveToken(sendToken)
      getSwapConstantData(receiveToken, sendToken)
    }
    else {
      if (tokenType === 'send') {
        setSendToken(selectedTokenData)
        if (Object.values(receiveToken).length > 0) {
          getSwapConstantData(selectedTokenData, receiveToken)
        } else {
          // console.log("set swap const data inside handle token select else 1")
          setSwapConsData({})
        }
      }
      if (tokenType === 'receive') {
        setReceiveToken(selectedTokenData)
        if (Object.values(sendToken).length > 0) {
          getSwapConstantData(sendToken, selectedTokenData)
        } else {
          // console.log("set swap const data inside handle token select else 2")
          setSwapConsData({})
        }
      }
      setIntermediateTokenArray([])
    }
    
    setExistTokeAdd('')
    setSendAmount('')
    setSendAmountWithoutComma(0)
    setReceiveAmountWithoutComma(0)
    setPriceImpact('0.00')
    setReceiveAmount('')
    handleToggleModal()  
    handleMinReceive(0)  
    setSwapWarning(false)
    setMinReceive('0.00')
    // console.log("handle token select function", sendAmountWithoutComma)
  }

  const getSwapConstantData = async (firstToken: any, secondToken: any) => {
    try {
      const tokenAPrice = await getTokenPrice(firstToken.address)
      const tokenBPrice = await getTokenPrice(secondToken.address)
      setSwapConsData({
        tokenAPrice,
        tokenBPrice
      })
      
    } catch (error) {
      console.log("set swap const data inside get swap const data error condition", error)
      setSwapConsData({})
    }
  }

  const handleToggleModal = () => {
    setTokenType('')
    setShowTokenModal(false)
  }

  const handleSwapToken = async () => {
    setSendToken(receiveToken)
    setReceiveToken(sendToken);
    handleIsSendOrReceiveFilled(true)

    if (Object.values(sendToken).length > 0 && Object.values(receiveToken).length > 0) {
      let tokenAPrice = swapConstData.tokenBPrice;
      let tokenBPrice = swapConstData.tokenAPrice;
      setSwapConsData({
        tokenAPrice,
        tokenBPrice
      });
    }
  }

  const handleMaxAmount = async () => {
    let amount: any
    if (parseFloat(sendToken.usdValue) > 0.01) {
      
      if (sendToken.sno === bnbSno && parseFloat(sendToken.value) !== 0) {
        amount = sendToken.value
        amount -= 0.02
      } else {
        amount = sendToken.value
      }
      setSendAmountCheck(amount)
      let formatted_amount = getNumFormat(amount)
      setSendAmount(formatted_amount)
      setSendAmountWithoutComma(amount)
      setMaxButton(true)
    }
  }

  const handleApprove = async () => {
    try {
      // minSendAmountInWei - amount for approval
      setBtnLoading(true)
      const TOKEN_INSTANCE = await selectInstance(instanceType.PLANETLP, sendToken.address)
      const approvalAmount = maxAmount
      setConfirmSwapModal(false)
      await TOKEN_INSTANCE.methods
        .approve(planetZapOneInchAddress, minSendAmountInWei)
        .send({ from: selector.ethData.address })
        .once('transactionHash', function (res: any) {
          if (!!res && typeof res) {
            const transLink = `${transLinkUrl}/${res}`
            setTransactionLink(transLink)
            setShowTransModal(true)
          }
        })
        .once('confirmation', function (confNumber: any, receipt: any) {
          if (receipt && typeof receipt !== 'undefined') {
            setBtnStatus('swap')
            // setBtnLoading(false)
            // updateTokenList()
          }
        })
        .on('error', function (error: any) {
          setTransactionLink('')
          setBtnStatus('approve')
          setShowTransModal(false)
          console.log(error)
        })
    } catch (error) {
      console.log(error)
    } finally {
      setBtnLoading(false)
      setSendAmount(sendAmount)
      setSendAmountWithoutComma(+sendAmountWithoutComma)
      setSendToken(sendToken)
      setReceiveToken(receiveToken)
      getAllowance()
      //console.log("token details on approve", sendAmount, sendAmountWithoutComma, sendToken, receiveToken)
    }
  }

  const handleTransactionLink = (newLink: any, hashVal: any) => {
    const data: any = {
      firstToken: sendToken.name,
      secondToken: receiveToken.name,
      amount1: sendAmountWithoutComma,
      amount2: receiveAmountWithoutComma,
      link: newLink,
      type: 'swap',
      status: false,
      hashVal: hashVal,
      transStatus: 'pending',
    }
    setTransLink(data)
  }
  const handleNotification = (type: string, hash?: any) => {
    const linkUrl = !!hash ? `${transLinkUrl}/${hash}` : ''
    const data: any = {
      type: type,
      message: `Swap ${parseFloat(sendAmountWithoutComma.toString()).toFixed(4)} ${sendToken.name} for ${parseFloat(receiveAmountWithoutComma.toString()).toFixed(4)} ${receiveToken.name}`,
      link: linkUrl
    }
    dispatch(notificationClose())
    dispatch(notificationOpen(data))
  }

  const getProtocols: any = async() => {
    function nonPmm(protocol:any) {
      //console.log('protocol', protocol);
      return !protocol.includes('PMM');
    }
    let protocolsAr:any = protocols;
    // let protocols:any = await fetch(apiRequestUrl('/liquidity-sources'))
    //       .then(res => res.json())
    //       .then(res => res);
    //console.log('protocols', protocols);
    protocolsAr = protocolsAr.protocols.map(function(a:any) {return a.id;});
    return protocolsAr.filter(nonPmm) ;
  }

  const buildTxForSwap = async () => {
    try {
      let inputToken = sendToken.address;
      let protocols = await getProtocols();
      //console.log('protocols', protocols);
      protocols = protocols.toString();
  
      const swapParams = {
        src: inputToken, // 1INCH
        dst: receiveToken.address, // DAI
        amount: minSendAmountInWei,
        fromAddress: planetZapOneInchAddress,
        slippage: slippageVal,
        disableEstimate: true,
        allowPartialFill: false,
        referrerAddress: referralAddress,
        fee: 0,//referralFees,
        protocols: protocols
      };
  
      // console.log('swapParams', swapParams);
      const url = apiRequestUrl('/swapDataNew', swapParams.dst, swapParams.src, swapParams.amount, swapParams.slippage, selector.ethData.address, planetZapOneInchAddress);
  
      return fetch(url).then(res => res.json()).then(res => res);
    } catch(error) {
      console.log(error)
      let inputToken = sendToken.address;
      let protocols = await getProtocols();
      //console.log('protocols', protocols);
      protocols = protocols.toString();
  
      const swapParams = {
        src: inputToken, // 1INCH
        dst: receiveToken.address, // DAI
        amount: minSendAmountInWei, //maxButton == true && sendToken.maxBalanceInWei ? sendToken.maxBalanceInWei: minSendAmountInWei,
        fromAddress: planetZapOneInchAddress,
        slippage: slippageVal,
        disableEstimate: true,
        allowPartialFill: false,
        referrerAddress: referralAddress,
        fee: 0,//referralFees,
        protocols: protocols
      };
  
      // console.log('swapParams in else', swapParams);
      const url = apiRequestUrl('/swapDataNew', swapParams.dst, swapParams.src, swapParams.amount, swapParams.slippage, selector.ethData.address, planetZapOneInchAddress);
  
      return fetch(url).then(res => res.json()).then(res => res);
    }
    
  }


  const handle1InchSwap = async () => { 
    setBtnLoading(true);
    let swapTransaction = await buildTxForSwap(); //inputToken: any, receiveToken: any, minSendAmountInWei: any, slippageVal: any, userAddress: any, fromAddress: any
    let tx = swapTransaction.tx;
    const userAddress = selector.ethData.address.replace('0x', '');
    const _planetZapOneInchAddress = planetZapOneInchAddress.replace('0x', '');
    tx = tx.data.replace(userAddress.toLowerCase(), _planetZapOneInchAddress.toLowerCase())
    //console.log('Transaction for swap: ', swapTransaction);
    try{
      if(sendToken.address.toLowerCase() == bnbAddress.toLowerCase()) {
        //console.log('swapConstData', swapConstData);
        //console.log('swapTransaction', swapTransaction);
        let priceA:any = swapConstData.tokenAPrice
        let priceB:any = swapConstData.tokenBPrice
        let fromTokenAmount = swapTransaction.fromTokenAmount;
        let toTokenAmount = swapTransaction.toTokenAmount;
        let pricePaidPerTokenB: any = fromTokenAmount / toTokenAmount
        let priceRatio = priceB / priceA ;
        //console.log('priceRatio', priceRatio, pricePaidPerTokenB);
        const impact: any = (Math.abs(pricePaidPerTokenB - priceRatio) / priceRatio) * 100
          
        //console.log('impact', impact);

        if(impact > 5) {
          handleNotification('failed')
          setShowTransModal(false)
          setBtnLoading(false)
          return
        }


        const swapInstance: any = new wallet.web3.eth.Contract(planetZapOneInchAbi, planetZapOneInchAddress);
        await swapInstance.methods
          .swapFromBNB(tx, receiveToken.address)
          .send({
            from: userAddress,
            value: maxButton == true && sendToken.maxBalanceInWei ? sendToken.maxBalanceInWei : minSendAmountInWei
          }).on('sending', async function (res: any) {
            setConfirmSwapModal(false);
          }).once('transactionHash', async function (res: any) {
            if (res && typeof res !== 'undefined') {
              const transLink = `${transLinkUrl}/${res}`
              setTransactionLink(transLink)
              handleTransactionLink(transLink, res)
              setShowTransModal(true)
            }
          }).once('confirmation', function (confNumber: any, receipt: any) {
            setConfirmTransLink(receipt.transactionHash, receipt.status)
            const type = receipt.status ? 'success' : 'failed'
            handleNotification(type, receipt.transactionHash)
            // setBtnLoading(false)
            dispatch(silentUpdateOnInfStake(selector.ethData.address))
            dispatch(updateUserLendingData(selector.ethData.address))
            updateTokenList()
          })
          .on('error', function (error: any) {
            handleNotification('failed')
            setShowTransModal(false)
            setBtnLoading(false)
            dispatch(silentUpdateOnInfStake(selector.ethData.address))
            dispatch(updateUserLendingData(selector.ethData.address))
            updateTokenList()
          })
      }
      else {
        const swapInstance: any = new wallet.web3.eth.Contract(planetZapOneInchAbi, planetZapOneInchAddress);
        const swapAmount: any = minSendAmountInWei;//maxButton == true && sendToken.maxBalanceInWei ? sendToken.maxBalanceInWei : minSendAmountInWei;


        let priceA:any = swapConstData.tokenAPrice
        let priceB:any = swapConstData.tokenBPrice
        let v = convertToWei(swapAmount)
        let fromTokenAmount = swapTransaction.fromTokenAmount;
        let toTokenAmount = swapTransaction.toTokenAmount;
        let pricePaidPerTokenB: any = fromTokenAmount / toTokenAmount
        let priceRatio = priceB / priceA ;
        const impact: any = (Math.abs(pricePaidPerTokenB - priceRatio) / priceRatio) * 100
          
        if(impact > 5) {
          handleNotification('failed')
          setShowTransModal(false)
          setBtnLoading(false)
          return
        }
        console.log('impact', impact);
        
        await swapInstance.methods
          .swap(sendToken.address, swapAmount, tx, receiveToken.address)
          .send({
            from: userAddress,
            value: 0
          }).on('sending', async function (res: any) {
            setConfirmSwapModal(false);
          }).once('transactionHash', async function (res: any) {
            if (res && typeof res !== 'undefined') {
              const transLink = `${transLinkUrl}/${res}`
              setTransactionLink(transLink)
              handleTransactionLink(transLink, res)
              setShowTransModal(true)
            }
          }).once('confirmation', function (confNumber: any, receipt: any) {
            setConfirmTransLink(receipt.transactionHash, receipt.status)
            const type = receipt.status ? 'success' : 'failed'
            handleNotification(type, receipt.transactionHash)
            // setBtnLoading(false)
            // dispatch(silentUpdateOnInfStake(selector.ethData.address))
            // dispatch(updateUserLendingData(selector.ethData.address))
            dispatch(silentUpdateOnInfStake(selector.ethData.address))
            dispatch(updateUserLendingData(selector.ethData.address))
            updateTokenList()
          })
          .on('error', function (error: any) {
            handleNotification('failed')
            setShowTransModal(false)
            setBtnLoading(false)
          })
      }
    } catch (error){
      console.log(error)
      dispatch(silentUpdateOnInfStake(selector.ethData.address))
      dispatch(updateUserLendingData(selector.ethData.address))
      updateTokenList()
      
    } finally{
      setShowTransModal(false)
      setBtnLoading(false)
      setSendAmount('')
      setReceiveAmount('')
      setMinReceive('0.00')
      setSendAmountCheck(0)
      setSendAmountWithoutComma(0)
      setReceiveAmountWithoutComma(0)
      setSwapWarning(false)
      setMinReceive('0.00')
      setMaxButton(false)
      setPriceImpact('0.00')
      
    }
    
  }

  const handlePriceImpact = async (amount1: any, tokenA: any, tokenB: any, _swapConstData:any, quote:any) => {
    try {
      if (!!_swapConstData && Object.values(_swapConstData).length > 0) {
        let priceA:any = _swapConstData.tokenAPrice
        let priceB:any = _swapConstData.tokenBPrice
        let v = convertToWei(amount1)
        if(tokenB != undefined && tokenA != undefined && amount1 > 0 ) {
          let fromTokenAmount = quote.fromTokenAmount;
          let toTokenAmount = quote.toTokenAmount;
          let pricePaidPerTokenB: any = fromTokenAmount / toTokenAmount
          let priceRatio = priceB / priceA ;
          let amountA = (fromTokenAmount * priceA) / 1e18;
          let amountB = (toTokenAmount * priceB) / 1e18 ;
          //console.log(amountA, amountB, 'amountA B');
          if(amountB > amountA) {
            setPriceImpact('0.00')
            setSwapWarning(false)
          }
          else {
            const impact: any = (Math.abs(pricePaidPerTokenB - priceRatio) / priceRatio) * 100
            setPriceImpact(parseFloat(impact).toFixed(2))
            if(impact <= 5) {
              setSwapWarning(false);
            }
          }
        } else {
          setPriceImpact('0.00')
          setSwapWarning(false)
        }
      }
      else {
        setPriceImpact('0.00')
        setSwapWarning(false)
      }
    } 
    catch (err) {
      console.log('handle price impact', err)
      setPriceImpact('0.00')
      setSwapWarning(false)
    }
  }

  const sendInput = useRef<HTMLInputElement>(null);
  const receiveInput = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (sendInput.current) {
      sendInput.current.focus();
      // sendInput.current.autofocus = true;
    }
  },[sendInput.current])

  useEffect(() => {
    if (receiveInput.current) {
      // receiveInput.current.focus();
      // receiveInput.current.autofocus = true;
    }
  },[receiveInput.current])

  const handleTabClick:any = (tabName: string) => {
    history.push(`${Paths.root}${tabName}`)
  }

  const chainId = 56;
  const apiBaseUrl = 'https://pfapi.planet.finance/v1';//'https://api-planetfinance.1inch.io/v5.0/' + chainId;
  //const apiBaseUrl = 'https://api.1inch.io/v5.0/' + chainId;
  const apiRequestUrl:any = (methodName:any, dst: any, src: any, amount: any, fee?:any, fromAddress?: any) => {
    //console.log(fee)
    return fee == undefined ? apiBaseUrl + methodName + '/' + src + '/' + dst + '/' + amount : apiBaseUrl + methodName + '/' + src + '/' + dst + '/' + amount + '/' + fee + '/' + fromAddress;
  }

  const getQuote = async (dst:any, src:any, amount:any) => {
    let fee = 0;//referralFees;
    let protocols = await getProtocols();
    //console.log('protocols', protocols);
    protocols = protocols.toString();

    if(amount > 0 && dst != undefined && src != undefined) {
      let url = apiRequestUrl('/swapQuote', dst, src, amount)
      // console.log('url', url);
      return fetch(apiRequestUrl('/swapQuote', dst, src, amount))
          .then(res => res.json())
          .then((res: any) => { 
            res.fromToken = src;
            res.toToken = dst;
            res.fromTokenAmount = amount;
            res.toTokenAmount = res.toAmount;
            return res;
          });
    }
  }

  return (
    <TokenSwapCont className='swap test'>
      <>
        {/* {console.log('btnStatus', sendToken.value, sendAmountWithoutComma.toString(),  btnStatus, parseFloat(sendAmountWithoutComma.toString()) > parseFloat(sendToken.value) , sendAmountWithoutComma, sendToken, receiveAmount, sendAmount )} */}
        {/* {
          console.log('currTokenList',currTokenList)
        } */}
      </>
      <CardCont>
        <FlexSBCont>
          <TitleText className="swapText">Swap</TitleText>
          {/* <SwapHeaderCont className='swap'>
            <SwapStatusText className='tabText' activeStatus={activeTab === 'swap'} onClick={() => handleTabClick('swap')} >
              Swap
            </SwapStatusText>
            <SwapStatusText className='tabText' activeStatus={activeTab === 'liquidity'} onClick={() => handleTabClick('liquidity')}>
              Liquidity
            </SwapStatusText>
            <SwapStatusText className='tabText' onClick={()=> window.open("https://synapseprotocol.com/", "_blank")}>
              Bridge
            </SwapStatusText>
          </SwapHeaderCont> */}
          <FlexCont className="clock-setting">
            <img src={SettingIcon} alt="" onClick={() => setShowSettings(true)} />
            <img src={ClockIcon} alt="" onClick={() => setShowHistory(true)} />
          </FlexCont>
        </FlexSBCont>
        <SwapCard sendAmount={sendAmountCheck} className="swapBox">
          <FlexSBCont >
            {sendAmountCheck > 0 && !isNaN(swapConstData.tokenAPrice * +sendAmountWithoutComma) ?
            <InfoLDText>Send {`($${Object.values(sendToken).length > 0 ? commaFy(parseFloat((+swapConstData.tokenAPrice * +sendAmountWithoutComma).toString()).toFixed(2)) : '0'})`}</InfoLDText>
            :
            sendAmountCheck > 0 && isNaN(swapConstData.tokenAPrice * +sendAmountWithoutComma) ?
            <InfoLDText>Send <LoadingText1 /></InfoLDText>
            :
            <InfoLDText>Send</InfoLDText>
            }
            <InfoLDText>{`Balance: ${Object.values(sendToken).length > 0 ? commaFy(parseFloat(sendToken.value).toFixed(4)) : '-'}`}</InfoLDText>
          </FlexSBCont>
          <FlexSBCont className="swap-input">
            <TokenValInput
              disabled={!(Object.values(sendToken).length > 0 && Object.values(receiveToken).length > 0)}
              placeholder="0"
              onChange={handleSendAmount}
              value={sendAmount && sendAmount}
              autoFocus={true}
              ref={sendInput}
            />
            <FlexCont>
              {Object.values(sendToken).length > 0 && sendToken.usdValue > 0 ? <MaxTxt onClick={() => handleMaxAmount()}>Max</MaxTxt> : <MaxTxtZero onClick={() => handleMaxAmount()}>Max</MaxTxtZero>}
              <TokenSelectCont onClick={() => handleTokenModal('send')}>
                {Object.values(sendToken).length > 0 ? (
                  <>
                    <img className="token-icon" src={sendToken.icon} alt="" />
                    <TokenName>{sendToken.name}</TokenName>
                  </>
                ) : (
                  <SelectCurrTxt>Select Currency</SelectCurrTxt>
                )}
                <img className="arrow-down" src={ArrowDown} alt="" />
              </TokenSelectCont>
            </FlexCont>
          </FlexSBCont>
        </SwapCard>
        <SwapDownArrow className='swapIconBg' onClick={() => handleSwapToken()}>
          <img className='swapIconBg' src={SwapIcon} alt="" onMouseOver={e => e.currentTarget.src = SwapIconWhite} onMouseOut={e => e.currentTarget.src = SwapIcon} onTouchStart={e => e.currentTarget.src = SwapIcon}
          onTouchEnd={e => e.currentTarget.src = SwapIcon} onClickCapture={e => e.currentTarget.src = SwapIcon} />
        </SwapDownArrow>
        <SwapCard className="swapBox">

          <FlexSBCont>
            {sendAmountCheck > 0 && !isNaN(+minReceive * +swapConstData.tokenBPrice) ? 
            <InfoLDText>Receive {`${parseFloat(minReceive) > 0 ? "($" +commaFy((+minReceive * +swapConstData.tokenBPrice).toFixed(2)) + ")" : ''
              }`}</InfoLDText>
              :
              sendAmountCheck > 0 && !isNaN(+minReceive * +swapConstData.tokenBPrice) ?
              <InfoLDText>Receive <LoadingText1 /></InfoLDText>
              :
            <InfoLDText>Receive</InfoLDText>
            }
            <InfoLDText>{`Balance: ${Object.values(receiveToken).length > 0 ? commaFy(parseFloat(receiveToken.value).toFixed(4)) : '-'
              }`}</InfoLDText>
          </FlexSBCont>
          <FlexSBCont className="swap-input">
            <TokenValInput
              disabled={!(Object.values(sendToken).length > 0 && Object.values(receiveToken).length > 0)}
              placeholder="0"
              onChange={handleReceiveAmount}
              value={receiveAmount && receiveAmount}
              className="receiveInput"
              data={receiveAmountWithoutComma}
              ref={receiveInput}
              // autoFocus={true}
            />
            <FlexCont>
              <TokenSelectCont onClick={() => handleTokenModal('receive')}>
                {Object.values(receiveToken).length > 0 ? (
                  <>
                    <img className="token-icon" src={receiveToken.icon} alt="" />
                    <TokenName>{receiveToken.name}</TokenName>
                  </>
                ) : (
                  <SelectCurrTxt>Select Currency</SelectCurrTxt>
                )}
                <img className="arrow-down" src={ArrowDown} alt="" />
              </TokenSelectCont>
            </FlexCont>
          </FlexSBCont>
        </SwapCard>
        {isAmtLoading &&
          <PriceCont>
            <SwapConstTxt style={{ textAlign: 'center' }}> Amount loading...</SwapConstTxt>
          </PriceCont>
        }
        <PriceCont>
          {!!swapConstData && Object.values(swapConstData).length > 0 && (
            <div>
              {(
                <>
                  <FlexSBCont className="price-space">
                    <SwapConstTxt light>{`${sendToken.name} Price`}</SwapConstTxt>
                    <SwapConstTxt> ${commaFy(parseFloat(swapConstData.tokenAPrice).toFixed(2))}</SwapConstTxt>
                  </FlexSBCont>
                  <FlexSBCont>
                    <SwapConstTxt light>{`${receiveToken.name} Price`}</SwapConstTxt>
                    <SwapConstTxt> ${commaFy(parseFloat(swapConstData.tokenBPrice).toFixed(2))}</SwapConstTxt>
                  </FlexSBCont>
                </>
              )}
            </div>
          )}
        </PriceCont>
        {
        btnStatus === 'approve' && parseFloat(sendAmountWithoutComma.toString()) <= parseFloat(sendToken.value) ? (
          <BtnGroup className="btn-space">
            <PrimaryBtn disabled={btnLoading || parseFloat(sendAmountWithoutComma.toString()) <= 0 || parseFloat(receiveAmountWithoutComma.toString()) <= 0} onClick={() => handleApprove()}>
              {btnLoading ? <Spinner /> : 'Approve'}
            </PrimaryBtn>
            <PrimaryBtn disabled>Swap</PrimaryBtn>
          </BtnGroup>
        ) : btnStatus === 'swap' && parseFloat(priceImpact) <= 5  && parseFloat(sendAmount) > 0 ? (
          <PrimaryBtn className="btn-space" disabled={btnLoading || parseFloat(sendAmount) <= 0 || parseFloat(receiveAmount) <= 0 || isAmtLoading} onClick={() => setConfirmSwapModal(true)}>
            {btnLoading ? <Spinner /> : parseFloat(priceImpact) > 3 ? 'Swap Anyway' : 'Swap'}
          </PrimaryBtn>
        ) : (
          <PrimaryBtn className="btn-space" disabled>Swap</PrimaryBtn>
        )}
      </CardCont>
      {(
        <SwapConstCard className="swap-const-info">
          <FlexSBCont className="swap-const-data">
            <SwapConstTxt light>Minimum Received</SwapConstTxt>
            <SwapConstTxt>{commaFy(parseFloat(minReceive).toFixed(4))}</SwapConstTxt>
          </FlexSBCont>
         { <FlexSBCont className="swap-const-data">
            <SwapConstTxt light>Price Impact</SwapConstTxt>
            <PriceImpactTxt priceImpactVal={parseFloat(priceImpact)} className="priceImpact">{`${!!priceImpact && parseFloat(priceImpact) > 100 ? '99.99' : parseFloat(priceImpact) < 0 ? '0.00' : priceImpact
              }%`}</PriceImpactTxt>
          </FlexSBCont>}
          { swapWarning  &&
          <FlexSBCont className="swap-const-data">
            <PriceImpactTxt className="highSlippageWarning">High slippage value, please try a smaller amount for swap</PriceImpactTxt>
          </FlexSBCont>
          }
        </SwapConstCard>
      )}
      
      <CustomModal show={showTokenModal} toggleModal={handleToggleModal}>
        {showTokenModal && (
          <TokenSelect
            selectedAdd={tokenType === 'send' ? receiveToken.address : sendToken.address}
            setShowTokenModal={setShowTokenModal}
            tokenListVal={currTokenList}
            handleTokenSelect={handleTokenSelect}
            existTokenAdd={existTokenAdd}
            crossIconColor={'white'}
          />
        )}
      </CustomModal>
      <CustomModal show={confirmSwapModal} toggleModal={setConfirmSwapModal}>
        {confirmSwapModal && (
          <ConfirmSwap
            setConfirmSwapModal={setConfirmSwapModal}
            sendToken={sendToken}
            receiveToken={receiveToken}
            minReceive={minReceive}
            sendAmount={sendAmount}
            receiveAmount={receiveAmount}
            priceImpact={priceImpact}
            swapConstData={swapConstData}
            sendTokenPrice={swapConstData.tokenAPrice}
            ReceiveTokenPrice={swapConstData.tokenBPrice}
            crossIconColor={"white"}
            handle1InchSwap={handle1InchSwap}
          />
        )}
      </CustomModal>
      <CustomModal show={showTransModal} toggleModal={setShowTransModal}>
        {showTransModal && <TransactionInfo setShowTransModal={setShowTransModal} transactionLink={transactionLink} crossIconColor={"white"} />}
      </CustomModal>
      <CustomModal show={showSettings} toggleModal={setShowSettings}>
        {showSettings && (
          <Settings
            setShowSettings={setShowSettings}
            slippageVal={slippageVal}
            setSlippageVal={setSlippageVal}
            handleSlippage={handleSlippage}
            // deadLine={deadLine}
            // setDeadLine={setDeadLine}
            crossIconColor={"white"}
          />
        )}
      </CustomModal>
      <CustomModal show={showHistory} toggleModal={setShowHistory}>
        {showHistory && <TransHistory setShowHistory={setShowHistory} crossIconColor={"white"} />}
      </CustomModal>
    </TokenSwapCont>


  )
}

export default TokenSwap
